import { ApiEnvironment } from '../../models/api-environment';

export class AuthenticationEnvironment extends ApiEnvironment {
  get securityAuthenticateUrl() {
    return `${this.baseUrl}/api/v2/security/authenticate`;
  }

  get securityLogoutUrl() {
    return `${this.baseUrl}/api/v2/security/logout`;
  }

  get identityTokenUrl() {
    return `${this.baseUrl}/identity/v2/token`;
  }

  get trimbleidAuthenticateUrl() {
    return `${this.baseUrl}/api/v1/trimbleid/authenticate`;
  }

  get securityVerifyUrl() {
    return `${this.baseUrl}/api/v2/security/verify`;
  }

  override resolve(environment: unknown) {
    return environment instanceof AuthenticationEnvironment
      ? environment
      : this;
  }
}

export const authenticationEnvironment = new AuthenticationEnvironment();
